import React from "react";

function ErrorPage(props) {
  return (
    <div className="h-screen w-screen justify-center items-center grid font-lato-bold">
      <div className="text-center font-bold text-white flex-col flex justify-center">
        <div className="mb-[5vh] w-[80vw] lg:w-[30vw] self-center">
          <div className="w-full">
            <img src={props.logo} className="w-full"></img>
          </div>
        </div>
        <h1>Estamos em atualização,</h1>
        <h1>Desculpe pelo transtorno</h1>
        <h4 className="mt-[8vh]">
          Estamos trabalhando pela melhoria do nosso sistema por isso estamos em atualização, por favor volte mais tarde
        </h4>
      </div>
    </div>
  );
}

export default ErrorPage;
